import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { $t } from '@/i18n'
import moment from 'moment'
import { compareAndAddTimeString } from '@/helpers/functions/formatSfcHoraires'
import { Message } from 'element-ui'

export default {
  namespaced: true,
  state: {
    loadingEtablishmentSheet: false,
    saveEtablishmentAPI: {},
    etablishment: {
      id_externe: '',
      raison_sociale: '',
      nom_commerce: '',
      long_name: '',
      nom_contact_a_afficher: '',
      prenom_contact_a_afficher: '',
      telephone_a_afficher: '',
      telephone_a_afficher_2: '',
      telephone_a_afficher_3: '',
      telephone_mobile_a_afficher: '',
      email_contact_admin: '',
      statut_pdv: '',
      siret_entreprise: '',
      opening_date: '',
      media_store_codes: '',
      validation_mobile_phone: '',
      validation_email: '',
      adresse_commerce: '',
      adresse_2_commerce: '',
      code_postal_commerce: '',
      ville_commerce: '',
      country_code: '',
      latitude: '',
      longitude: '',
      sfc_horaire_lundi_ouv_1: '',
      sfc_horaire_lundi_fer_1: '',
      sfc_horaire_lundi_ouv_2: '',
      sfc_horaire_lundi_fer_2: '',
      sfc_horaire_mardi_ouv_1: '',
      sfc_horaire_mardi_fer_1: '',
      sfc_horaire_mardi_ouv_2: '',
      sfc_horaire_mardi_fer_2: '',
      sfc_horaire_mercredi_ouv_1: '',
      sfc_horaire_mercredi_fer_1: '',
      sfc_horaire_mercredi_ouv_2: '',
      sfc_horaire_mercredi_fer_2: '',
      sfc_horaire_jeudi_ouv_1: '',
      sfc_horaire_jeudi_fer_1: '',
      sfc_horaire_jeudi_ouv_2: '',
      sfc_horaire_jeudi_fer_2: '',
      sfc_horaire_vendredi_ouv_1: '',
      sfc_horaire_vendredi_fer_1: '',
      sfc_horaire_vendredi_ouv_2: '',
      sfc_horaire_vendredi_fer_2: '',
      sfc_horaire_samedi_ouv_1: '',
      sfc_horaire_samedi_fer_1: '',
      sfc_horaire_samedi_ouv_2: '',
      sfc_horaire_samedi_fer_2: '',
      sfc_horaire_dimanche_ouv_1: '',
      sfc_horaire_dimanche_fer_1: '',
      sfc_horaire_dimanche_ouv_2: '',
      sfc_horaire_dimanche_fer_2: '',
      sfc_horaires_exceptionnels: '',
      videos: []
    },
    codePostalVille: [],
    loadingPhotos: false,
    files: {
      logo: [],
      cover: [],
      profile: [],
      gallery: []
    }
  },
  getters: {
    getEtablishmentSheet: (state) => state.etablishment,
    getLoadingEtablishment: (state) => state.loadingEtablishmentSheet,
    getLoadingPhotos: (state) => state.loadingPhotos,
    getCodePostalVille: (state) => state.codePostalVille,
    getFilesByType: (state) => (type) => state.files[type],
    getVideos: (state) => state.etablishment.videos
  },
  mutations: {
    setLoadingEtablishmentSheet (state, bool) {
      state.loadingEtablishmentSheet = bool
    },
    setLoadingPhotos (state, bool) {
      state.loadingPhotos = bool
    },
    setEtablishment (state, data) {
      state.etablishment = data
    },
    setSaveEtablishmentAPI (state, data) {
      state.saveEtablishmentAPI = data
    },
    setCodePostalVille (state, data) {
      state.codePostalVille = data
    },
    setFiles (state, payload) {
      state.files = payload
    },
    addFile (state, { type, file }) {
      if (type === 'gallery' && state.files.gallery.length < 10) {
        state.files.gallery.push(file)
      } else if (type !== 'gallery') {
        if (!state.files[type].some(f => f.id === file.id)) {
          state.files[type].push(file)
        }
      }
    },
    removeFile (state, { type, file }) {
      if (state.files[type]) {
        state.files[type] = state.files[type].filter(f => f.uid !== file.uid)
      }
    },
    setVideos (state, videos) {
      state.etablishment.videos = videos
    }
  },
  actions: {
    loadEtablishmentSheet ({ commit }) {
      commit('setLoadingEtablishmentSheet', true)
      HTTP_HYPER_ESPACE_BACKEND.get('/etablishment-sheet')
        .then(response => {
          commit('setEtablishment', response.data)
          commit('setSaveEtablishmentAPI', response.data)
        })
        .catch(() => {
          Message.error($t('etablishmentSheet.messageLoadData'))
        }).finally(() => {
          commit('setLoadingEtablishmentSheet', false)
        })
    },
    updateEtablishment ({ state, commit }) {
      commit('setLoadingEtablishmentSheet', true)
      const differences = {}
      HTTP_HYPER_ESPACE_BACKEND.get('/etablishment-sheet')
        .then(response => {
          const data = response.data
          for (const key in state.etablishment) {
            if (state.etablishment[key] !== data[key]) {
              differences[key] = state.etablishment[key]
              if (key === 'opening_date') {
                differences[key] = moment(state.etablishment[key]).format('DD/MM/YYYY')
              }
            }
            const exceptionalDays = compareAndAddTimeString(data.sfc_horaires_exceptionnels, state.etablishment.sfc_horaires_exceptionnels)
            if (key === 'sfc_horaires_exceptionnels' && exceptionalDays !== undefined && exceptionalDays !== '' && exceptionalDays !== ';') {
              if (exceptionalDays !== '' && exceptionalDays !== ';') {
                differences[key] = exceptionalDays + ';'
              }
            }
          }
          commit('setLoadingEtablishmentSheet', true)
          HTTP_HYPER_ESPACE_BACKEND.patch('/etablishment-sheet/update', differences)
            .then(response => {
              if (response.data.errors) {
                const code = response.data.errors[0].code
                Message.warning($t(`etablishmentSheet.errorPhoto${code}`))
              } else {
                commit('setEtablishment', response.data)
                Message.success($t('etablishmentSheet.successSave'))
              }
            })
            .catch((error) => {
              Message.warning($t('etablishmentSheet.errorSave'))
            }).finally(() => {
              commit('setLoadingEtablishmentSheet', false)
            })
        })
    },
    searchByPostalCode ({ commit }, { queryString, pays }) {
      let url = '/v2/ville-code-postal?nbMax=40&codePostal=' + queryString
      if (pays != null) {
        url = url + '&pays=' + pays
      }
      HTTP_HYPER_ESPACE_BACKEND.get(url)
        .then((response) => {
          commit('setCodePostalVille', response.data)
        })
    },
    loadListPhotosDBKS ({ commit }) {
      commit('setLoadingPhotos', true)
      HTTP_HYPER_ESPACE_BACKEND.get('/list/photos')
        .then(response => {
          const data = response.data
          const formattedData = {
            logo: data.filter(file => file.type === 'LOGO'),
            cover: data.filter(file => file.type === 'COVER'),
            profile: data.filter(file => file.type === 'PROFILE'),
            gallery: data.filter(file => file.type === 'GALLERY')
          }
          commit('setFiles', formattedData)
        })
        .catch(() => {
          Message.error($t('etablishmentSheet.messageLoadData'))
        }).finally(() => {
          commit('setLoadingPhotos', false)
        })
    },
    addFile ({ commit }, { type, file }) {
      commit('addFile', { type, file })
    },
    removeFile ({ state, commit, dispatch }, { type, file }) {
      dispatch('deletePhotoDBKS', { type: type, file: file })
      commit('removeFile', { type, file })
    },
    uploadPhotosDBKS ({ state, commit, dispatch }) {
      commit('setLoadingPhotos', true)
      const uploads = []

      Object.keys(state.files).forEach((section) => {
        state.files[section]
          .filter((file) => !file.id && !file.sourcePath)
          .forEach((file, index) => {
            if (section === 'gallery') {
              uploads.push({ type: `${section}_${index}`, file: file })
            } else {
              uploads.push({ type: section, file: file })
            }
          })
      })

      // Créer un FormData
      const formData = new FormData()
      uploads.forEach((upload) => {
        formData.append(upload.type, upload.file.raw) // un fichier
      })
      HTTP_HYPER_ESPACE_BACKEND.post('/upload/photos', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        if (response.data.errors) {
          const code = response.data.errors[0].code
          Message.warning($t(`etablishmentSheet.errorPhoto${code}`))
        }
        if (response.data === 'OK') {
          dispatch('loadListPhotosDBKS')
          Message.success($t('etablishmentSheet.messageUploadPhotoSuccess'))
        }
      }).finally(() => {
        commit('setLoadingPhotos', false)
      })
    },
    deletePhotoDBKS ({ state, commit }, { type, file }) {
      if (file.id && file.sourcePath) {
        commit('setLoadingPhotos', true)
        HTTP_HYPER_ESPACE_BACKEND
          .delete(`/delete/photo?type=${type}&id=${file.id}`)
          .then(response => {
            if (response.status === 200 && response.data === 'OK') {
              Message.success($t('etablishmentSheet.messageDeletedPhotoSuccess'))
            }
          })
          .catch(() => {
            Message.error($t('etablishmentSheet.messageDeletedPhotoError'))
          })
          .finally(() => {
            commit('setLoadingPhotos', false)
          })
      }
    }
  }
}
